var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUnpin(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    rx: 4,
    fill: "#313131"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.848 14.7603L16.9443 17.8512C17.1431 18.0496 17.4653 18.0496 17.664 17.8512C17.8628 17.6528 17.8628 17.3312 17.664 17.1328L6.86874 6.35641C6.67 6.15802 6.34779 6.15802 6.14905 6.35641C5.95032 6.55479 5.95032 6.87644 6.14905 7.07483L9.2962 10.2165C9.11262 10.2864 8.93437 10.3737 8.76045 10.482L8.4453 10.7966C8.18032 11.0611 8.18032 11.49 8.4453 11.7545L10.0011 13.3076L6.4679 16.8346L6.12864 17.8506L7.14646 17.5119L10.6796 13.9849L12.2354 15.538C12.5004 15.8025 12.93 15.8025 13.195 15.538L13.5101 15.2234C13.6556 15.0782 13.7656 14.9231 13.848 14.7603ZM15.628 10.3998L14.1423 11.883L12.1067 9.85095L13.5924 8.36783L13.447 8.22268C12.9652 7.74172 12.9652 6.96193 13.447 6.48096C14.0402 5.88883 14.9737 5.84345 15.619 6.3448L15.628 6.33582L17.6636 8.36783L17.6546 8.37681C18.1568 9.02102 18.1114 9.95285 17.5182 10.545C17.0364 11.0259 16.2552 11.0259 15.7734 10.545L15.628 10.3998Z",
    fill: "current"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUnpin);
export default __webpack_public_path__ + "static/media/Unpin.8850e7df240457cfd19a1b6a77d9bca1.svg";
export { ForwardRef as ReactComponent };